import gsap from "gsap";
import {Power0} from "gsap";

const showHiddenCardPart = () => {

    document.addEventListener('click', ev => {
        if (!ev.target.closest('.kirinus-carousel-card--toggle')) return;
        ev.preventDefault();
        ev.stopPropagation();
        let parentCard = ev.target.closest('.kirinus-carousel-card')
        if (parentCard.classList.contains('kirinus-carousel-card__team')) {
            let tl = gsap.timeline({})
            let cardText = parentCard.querySelector('.card-text');
            let cardTitle = parentCard.querySelector('.card-title');
            let cardBody = parentCard.querySelector('.card-body');
            let toggle = ev.target;
            let cardShade = parentCard.querySelector('.kirinus-carousel-card__team-shade');
            tl.timeScale(3)
            if (!parentCard.classList.contains('kirinus-carousel-card__dark')) {
                tl.fromTo(cardText, {opacity: 0}, {opacity: 1, duration: 1}, 1);
                tl.to(cardText, {display: 'block', duration: 1}, 1);
                // tl.fromTo(cardTitle,{y: '100%'}, {y: 0, duration: 1}, 1)
                tl.to(cardBody, {justifyContent: 'flex-start', duration: 0.5}, 1);
                tl.fromTo(cardShade, {height: '0%'}, {height: '100%', duration: 1}, 1)
                tl.fromTo(toggle, {rotation: 0}, {
                    rotation: 45,
                    filter: 'brightness(0) invert(1)',
                    ease: Power0.easeInOut,
                    duration: 0.5
                }, 1)
            } else {
                tl.to(cardText, {display: 'none', duration: 0.1}, 1);
                tl.to(cardBody, {justifyContent: 'flex-end', duration: 1}, 1);


                //tl.fromTo(cardTitle,{y: 0}, {y: '100%', duration: 1}, 1)

                tl.fromTo(cardText, {opacity: 1}, {opacity: 0, duration: 1}, 1);


                tl.fromTo(cardShade, {height: '100%'}, {height: '0%', duration: 1}, 1)
                tl.fromTo(toggle, {rotation: 45, filter: 'brightness(0) invert(1)'}, {
                    rotation: 0,
                    filter: '',
                    ease: Power0.easeInOut,
                    duration: 0.5
                }, 1)

            }
        }
        parentCard.classList.toggle('kirinus-carousel-card__dark');

    })
}
export default showHiddenCardPart;